var render, staticRenderFns
import script from "./billsToPay.vue?vue&type=script&lang=js&"
export * from "./billsToPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7d330",
  null
  
)

export default component.exports